module.exports = __webpack_public_path__ + "static/media/tirrenia.e1108524.svg";